<template>
    <div class="mc-container">
    <span class="mc-container__title" v-if="!!title" v-text="title">
    </span>
        <div class="mc-container__title" v-if="!title && hasTitleSlot">
            <slot class="mc-container__title"  name="title"></slot>
        </div>
        <aside class="mc-container__slot" :class="'is-'+align">
            <slot></slot>
        </aside>
        <p class="mc-container__tips" v-if="tips">
            {{tips}}
        </p>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        name: 'mc-container',
        props: {
            title: {
                type: String,
                default: ''
            },
            tips: {
                type: String,
                default: ''
            },
            align: {
                type: String,
                default: 'left'
            }
        },
        computed: {
            hasTitleSlot(){
                return !!this.$slots.title
            }
        },
        mounted(){
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/base-container.vue